import { WidgetActionsCnt } from 'pages/Dashboards/Widgets/widgetActions/style';
import ExportWidgetDropdown from 'pages/Dashboards/Widgets/widgetActions/exportDropdown/exportDropdown';
import WidgetActionDropdown from 'pages/Dashboards/Widgets/widgetActions/actionDropdown';
import EditButton from 'pages/Dashboards/Widgets/widgetActions/editButton/edit';
import { isEditable } from '@testing-library/user-event/dist/utils';
import WithDashboardPermission from 'pages/Dashboards/withDashboardPermission';
interface IWidgetActionsProps {
  exportChartToImage: () => void;
  widgetId: string;
  editable?: boolean;
}
function WidgetActions({
  exportChartToImage,
  widgetId,
  editable,
}: IWidgetActionsProps) {
  return (
    <WidgetActionsCnt>
      <ExportWidgetDropdown exportChartToImage={exportChartToImage} />
      <WithDashboardPermission>
        {editable && <EditButton widgetId={widgetId} />}
        {editable && <WidgetActionDropdown widgetId={widgetId} />}
      </WithDashboardPermission>
    </WidgetActionsCnt>
  );
}

export default WidgetActions;
